import React from "react";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";

const Chapter7Questions = () => {
  const questions = [
    "What is the purpose of dissemination in the research process?",
    "Who are the key audiences for sharing research findings?",
    "Why is it important to involve the Community Health Officer (CHO) in dissemination?",
    "What are some effective methods for engaging the community during dissemination?",
    "How can joint projects between facilities enhance dissemination efforts?",
    "What visual tools can be used to make research findings more accessible?",
    "Why is collaboration with local leaders and government officials important in dissemination?",
    "How can research findings be tailored to influence policy decisions?",
    "What are the benefits of using community meetings for sharing research findings?",
    "How does dissemination help bridge the gap between research and action?"
  ];

  return (
    <div>
      <StickyNavbar />
      <div className="bg-gray-50 min-h-screen p-8 mt-10">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h1 className="text-3xl font-bold text-blue-900">
            Chapter 7 Questions
          </h1>
        </motion.div>
        <motion.ul
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="space-y-4 text-lg"
        >
          {questions.map((question, index) => (
            <motion.li
              key={index}
              whileHover={{ scale: 1.05, x: 10 }}
              className="bg-white shadow-md p-4 rounded-lg border border-gray-200"
            >
              {index + 1}. {question}
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </div>
  );
};

export default Chapter7Questions;
